<template>
  <div class="chess-notation">
    <div class="chess-notation__results">
      <!-- {{ notation.join('') }} -->
      <template v-for="note, i in notation" :key="i">
        <button v-if="note.length" @click="goTo(i)" class="monospace" :class="{'is-specifying-origin': i === 1 || i === 2, 'is-active': i === step}">
          {{ note
            .replace('P', color !== 'white' ? '♙' : '♟︎')
            .replace('R', color !== 'white' ? '♖' : '♜')
            .replace('N', color !== 'white' ? '♘' : '♞')
            .replace('B', color !== 'white' ? '♗' : '♝')
            .replace('K', color !== 'white' ? '♔' : '♚')
            .replace('Q', color !== 'white' ? '♕' : '♛')
          }}
        </button>
        <span v-if="isSpecifyingOrigin && i === 1 && step === 1 && !notation[1].length" class="chess-notation__button-placeholder is-specifying-origin">&nbsp;</span>
        <span v-if="isSpecifyingOrigin && i === 2 && step === 2 && !notation[2].length" class="chess-notation__button-placeholder is-specifying-origin">&nbsp;</span>

      </template>
      <span v-if="(notation[4].length === 0 || this.step === 5) && !isSpecifyingOrigin" class="chess-notation__button-placeholder">&nbsp;</span>
      <button v-else-if="step !== 6" class="chess-notation__final-step-button monospace" @click="step = 6">{{ formatNotation }}</button>
    </div>
    <div v-if="step === 0" class="chess-notation__piece">
      <div class="chess-notation__piece-proper">
        <button @click="notate('P', 3)" :class="{'is-active': notation[step] === 'P'}">&nbsp;</button>
        <button @click="notate('R', 3)" :class="{'is-active': notation[step] === 'R'}">R</button>
        <button @click="notate('N', 3)" :class="{'is-active': notation[step] === 'N'}">N</button>
        <button @click="notate('B', 3)" :class="{'is-active': notation[step] === 'B'}">B</button>
        <button @click="notate('K', 3)" :class="{'is-active': notation[step] === 'K'}">K</button>
        <button @click="notate('Q', 3)" :class="{'is-active': notation[step] === 'Q'}">Q</button>
      </div>
      <div v-if="canCastle" class="chess-notation__castling">
        <button @click="notate('O-O', 6)" :class="{'is-active': notation[step] === 'O-O'}">Kingside castle</button>
        <button @click="notate('O-O-O', 6)" :class="{'is-active': notation[step] === 'O-O-O'}">Queenside castle</button>
      </div>
    </div>
    <div v-if="step === 1 || step === 3"  class="chess-notation__file" :class="{'is-specifying-origin': isSpecifyingOrigin}">
      <div v-if="isSpecifyingOrigin" class="chess-notation__file-proper">
        <button 
          @click="notate(notation[step] === 'a' ? '' : 'a', 3)" 
          :class="{'is-active': notation[step] === 'a'}"
        >
          {{ notation[step] === 'a' ? 'clear' : 'a' }}
        </button>
        <button 
          @click="notate(notation[step] === 'b' ? '' : 'b', 3)" 
          :class="{'is-active': notation[step] === 'b'}"
        >
          {{ notation[step] === 'b' ? 'clear' : 'b' }}
        </button>
        <button 
          @click="notate(notation[step] === 'c' ? '' : 'c', 3)" 
          :class="{'is-active': notation[step] === 'c'}"
        >
          {{ notation[step] === 'c' ? 'clear' : 'c' }}
        </button>
        <button 
          @click="notate(notation[step] === 'd' ? '' : 'd', 3)" 
          :class="{'is-active': notation[step] === 'd'}"
        >
          {{ notation[step] === 'd' ? 'clear' : 'd' }}
        </button>
        <button 
          @click="notate(notation[step] === 'e' ? '' : 'e', 3)" 
          :class="{'is-active': notation[step] === 'e'}"
        >
          {{ notation[step] === 'e' ? 'clear' : 'e' }}
        </button>
        <button 
          @click="notate(notation[step] === 'f' ? '' : 'f', 3)" 
          :class="{'is-active': notation[step] === 'f'}"
        >
          {{ notation[step] === 'f' ? 'clear' : 'f' }}
        </button>
        <button 
          @click="notate(notation[step] === 'g' ? '' : 'g', 3)" 
          :class="{'is-active': notation[step] === 'g'}"
        >
          {{ notation[step] === 'g' ? 'clear' : 'g' }}
        </button>
        <button 
          @click="notate(notation[step] === 'h' ? '' : 'h', 3)" 
          :class="{'is-active': notation[step] === 'h'}"
        >
          {{ notation[step] === 'h' ? 'clear' : 'h' }}
        </button>
      </div>
      <div v-else class="chess-notation__file-proper">
        <button @click="notate('a', 4)" :class="{'is-active': notation[step] === 'a'}">a</button>
        <button @click="notate('b', 4)" :class="{'is-active': notation[step] === 'b'}">b</button>
        <button @click="notate('c', 4)" :class="{'is-active': notation[step] === 'c'}">c</button>
        <button @click="notate('d', 4)" :class="{'is-active': notation[step] === 'd'}">d</button>
        <button @click="notate('e', 4)" :class="{'is-active': notation[step] === 'e'}">e</button>
        <button @click="notate('f', 4)" :class="{'is-active': notation[step] === 'f'}">f</button>
        <button @click="notate('g', 4)" :class="{'is-active': notation[step] === 'g'}">g</button>
        <button @click="notate('h', 4)" :class="{'is-active': notation[step] === 'h'}">h</button>
      </div>
      <div class="chess-notation__file-controls">
        <button 
          v-if="!isSpecifyingOrigin"
          class="chess-notation__note-start-button"
          @click="handleOriginClick" 
          :disabled="!['P', 'R', 'N', 'Q'].includes(notation[0])"
        >
          Note Starting Position
        </button>
        <div v-else class="chess-notation__specify-origin">
          Note Starting <span class="switch"><button class="is-active">File</button><button @click="step = 2">Rank</button></span>
          <button class="ex-button" @click="isSpecifyingOrigin = false; step = 3;">✕</button>

        </div>
      </div>
    </div>
    <div v-if="step === 2 || step === 4"  class="chess-notation__rank" :class="{'is-specifying-origin': isSpecifyingOrigin}">
      <div v-if="isSpecifyingOrigin" class="chess-notation__rank-proper">
        <button 
          @click="notate(notation[step] === '1' ? '' : '1', 3)" 
          :class="{'is-active': notation[step] === '1'}"
        >
          {{ notation[step] === '1' ? 'clear' : '1' }}
        </button>
        <button 
          @click="notate(notation[step] === '2' ? '' : '2', 3)" 
          :class="{'is-active': notation[step] === '2'}"
        >
          {{ notation[step] === '2' ? 'clear' : '2' }}
        </button>
        <button 
          @click="notate(notation[step] === '3' ? '' : '3', 3)" 
          :class="{'is-active': notation[step] === '3'}"
        >
          {{ notation[step] === '3' ? 'clear' : '3' }}
        </button>
        <button 
          @click="notate(notation[step] === '4' ? '' : '4', 3)" 
          :class="{'is-active': notation[step] === '4'}"
        >
          {{ notation[step] === '4' ? 'clear' : '4' }}
        </button>
        <button 
          @click="notate(notation[step] === '5' ? '' : '5', 3)" 
          :class="{'is-active': notation[step] === '5'}"
        >
          {{ notation[step] === '5' ? 'clear' : '5' }}
        </button>
        <button 
          @click="notate(notation[step] === '6' ? '' : '6', 3)" 
          :class="{'is-active': notation[step] === '6'}"
        >
          {{ notation[step] === '6' ? 'clear' : '6' }}
        </button>
        <button 
          @click="notate(notation[step] === '7' ? '' : '7', 3)" 
          :class="{'is-active': notation[step] === '7'}"
        >
          {{ notation[step] === '7' ? 'clear' : '7' }}
        </button>
        <button 
          @click="notate(notation[step] === '8' ? '' : '8', 3)" 
          :class="{'is-active': notation[step] === '8'}"
        >
          {{ notation[step] === '8' ? 'clear' : '8' }}
        </button>
      </div>
      <div v-else class="chess-notation__rank-proper">
        <button @click="notate('1', isPromoting('black') ? 5 : 6)" :class="{'is-active': notation[step] === '1'}">1</button>
        <button @click="notate('2', 6)" :class="{'is-active': notation[step] === '2'}">2</button>
        <button @click="notate('3', 6)" :class="{'is-active': notation[step] === '3'}">3</button>
        <button @click="notate('4', 6)" :class="{'is-active': notation[step] === '4'}">4</button>
        <button @click="notate('5', 6)" :class="{'is-active': notation[step] === '5'}">5</button>
        <button @click="notate('6', 6)" :class="{'is-active': notation[step] === '6'}">6</button>
        <button @click="notate('7', 6)" :class="{'is-active': notation[step] === '7'}">7</button>
        <button @click="notate('8', isPromoting('white') ? 5 : 6)" :class="{'is-active': notation[step] === '8'}">8</button>
      </div>
      <div class="chess-notation__rank-controls">
        <button 
          v-if="!isSpecifyingOrigin"
          class="chess-notation__note-start-button"
          @click="handleOriginClick" 
          :disabled="!['P', 'R', 'N', 'Q'].includes(notation[0])"
        >
          Note Starting Position
        </button>
        <div v-else class="chess-notation__specify-origin">
          Note Starting <span class="switch"><button @click="step = 1">File</button><button class="is-active">Rank</button></span>
          <button class="ex-button" @click="isSpecifyingOrigin = false; step = 3;">✕</button>
        </div>
      </div>
    </div>
    <div v-if="step === 5" class="chess-notation__promotion">
      <div class="chess-notation__promotion-label">Promote pawn to:</div>
      <div class="chess-notation__promotion-proper">
        <button @click="notate('=Q', 6)" :class="{'is-active': notation[step] === '=Q'}">=Q</button>
        <button @click="notate('=N', 6)" :class="{'is-active': notation[step] === '=N'}">=N</button>
        <button @click="notate('=R', 6)" :class="{'is-active': notation[step] === '=R'}">=R</button>
        <button @click="notate('=B', 6)" :class="{'is-active': notation[step] === '=B'}">=B</button>
      </div>
    </div>
    <div v-if="step === 6" class="chess-notation__final-results" :class="{'is-invalid': isValid === false, 'is-pending': isValid === null}">
      <span>{{  formatNotation }}</span>
      <button @click="finish" class="chess-notation__confirm-button">
        <svg v-if="isValid === false" class="chess-notation__error" viewBox="0 0 18 18">
          <path d="M9.0036 6.2399L9.0036 8.13385"/>
          <path d="M9.0036 11.0612L9.0036 11.1849"/>
          <circle cx="9.02417" cy="8.67285" r="6.68808"/>
        </svg>
        <svg v-else-if="isValid === true" class="chess-notation__check" viewBox="0 0 18 18">
          <path d="M15.2608 7.05127L7.05125 15.2608L2.73918 10.9487" />
        </svg>
        <span v-else class="chess-notation__pending">Waiting for {{ color === 'white' ? 'black' : 'white'}}</span>
      </button>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'ChessNotation',
    props: {
      color: {
        type: String,
        default: undefined
      },
      isValid: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        notation: ['','','','','',''],
        step: 0,
        isSpecifyingOrigin: false,
        canCastle: true
      }
    },
    watch: {
      step(newStep) {
        if (newStep === 6)
          this.$emit('validate', {'color': this.color, 'notation': this.formatNotation});
      }
    },
    methods: {
      notate(notation, step) {
        // Remove other notation if castling
        if (notation.indexOf('O-O') > -1)
          this.notation = ['','','','','',''];

        this.notation[this.step] = notation;

        // Remove promotion if edited to not be relevant
        if (this.step === 4 && ((notation !== '1' && this.isPromoting('black')) || (notation !== '8' && this.isPromoting('white'))))
          this.notation[5] = '';

        this.step = step;

        this.$emit('isCramped', this.notation.filter(n => n.length).length > 4);

        this.isSpecifyingOrigin = false;

      },
      reset() {
        this.step = 0;
        this.notation = ['','','','',''];
      },
      finish() {
        if (!this.isValid) {
          if (!confirm(`${this.formatNotation} is invalid. This might be because of an earlier mistake. Are you sure you want to save it?`))
            return;
        }
        if (this.notation[0].includes("O-O") || this.notation.includes('K'))
          this.canCastle = false;
        this.$emit('notate', this.formatNotation);
        this.reset();
      },
      handleOriginClick() {
        this.isSpecifyingOrigin = !this.isSpecifyingOrigin;

        // If origin file has not been specified go to it, otherwise go to origin rank
        if (this.notation[1].length === 0)
          this.step = 1;
        else
          this.step = 2;
      },
      isPromoting(color) {
        return color === this.color && this.notation[0] === 'P'; 
      },
      goTo(step) {
        this.step = step;
        if (step === 1 || step === 2)
          this.isSpecifyingOrigin = true;
        else
          this.isSpecifyingOrigin = false;
      }
    },
    computed: {
      formatNotation() {
        return this.notation.join('').replace('P', '');
      }
    }
  }
</script>

<style>

  .chess-notation {
    background: var(--plum);
  }

  .chess-notation button {
    border: 0;
    background: transparent;
    color: white;
    font-size: 18px;

  }

  :root .chess-notation__final-step-button {
    font-size: 12px;
    background: var(--magic);
    color: white;
  }

  :root .chess-notation__note-start-button {
    background: var(--origin);
  }

  .switch {
    display: inline-flex;
    background: var(--plum);
    padding: 2px;
    border-radius: 3px;
    border: 1px solid var(--mid);
  }

  .switch button {
    min-width: 70px;
  }

  .switch .is-active {
    border-radius: 2px;
    box-shadow: inset 0 0 0 1px var(--spice);
  }

  .switch button:not(.is-active) {
    color: var(--putty);
    opacity: .7;
  }

  .chess-notation__results {
    height: 7dvh;
    display: flex;
  }

  :root .is-specifying-origin {
    background: var(--origin);
  }

  .is-specifying-origin .is-active {
    font-size: 18px;
  }

  .chess-notation__confirm-button {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    display: flex;
    align-items: end;
    justify-content: end;
  }

  .chess-notation__results button,
  .chess-notation__button-placeholder {
    font-size: 3svh;
    min-width: max(40px, 11vw);
    border-radius: 3px;
    margin: 8px 4px;
    padding: 0 5px 0;
  }
  
  .chess-notation__results button {
    border: 2px solid var(--mid);
    background: var(--magic);
  }

  .chess-notation__button-placeholder {
    border: 2px dotted var(--mid);
    display: inline-block;
    background: var(--magic);
    position: relative;
  }

  .chess-notation__button-placeholder:before {
    content: '';
    width: 70%;
    height: 1px;
    border-bottom: 1px solid var(--putty);
    position: absolute;
    bottom: 5px;
    left: 15%;
  }

  .chess-notation__piece,
  .chess-notation__rank,
  .chess-notation__file,
  .chess-notation__final-results,
  .chess-notation__promotion {
    height: calc(100% - 7dvh);
  }

  .chess-notation__piece,
  .chess-notation__castling,
  .chess-notation__rank,
  .chess-notation__rank-controls,
  .chess-notation__file-controls,
  .chess-notation__file,
  .chess-notation__promotion {
    display: flex;
    flex-wrap: wrap;
  }

  .chess-notation__piece-proper,
  .chess-notation__file-proper,
  .chess-notation__rank-proper {
    width: 100%;
    height: 75%;
    display: flex;
    flex-wrap: wrap;
  }

  .chess-notation__promotion-label {
    height: 5dvh;
  }

  .chess-notation__promotion-proper {
    width: 100%;
    height: calc(100% - 7dvh);
  }

  .chess-notation__castling,
  .chess-notation__file-controls,
  .chess-notation__rank-controls {
    height: 25%;
    width: 100%;
  }

  .chess-notation__results button.is-specifying-origin {
    background-color: var(--origin);
  }

  .chess-notation__results button.is-active {
    outline: 3px solid var(--magic);
  }

  .chess-notation__specify-origin {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

   .chess-notation__castling button,
   .chess-notation__promotion-proper button {
      width: 50%;
      padding: 0;
   }

   .chess-notation__piece button,
   .chess-notation__file button,
   .chess-notation__rank button {
      flex-grow: 1;
  }

  .chess-notation__piece-proper button,
  .chess-notation__file-proper button,
  .chess-notation__rank-proper button {
    width: 33.33%;
    
    
  }

  .chess-notation__piece-proper button,
  .chess-notation__file-proper button,
  .chess-notation__rank-proper button,
  .chess-notation__promotion-proper button {
    height: 50%;
    outline: 1px solid var(--magic);
    font-family: var(--monospace);
    font-size: 35px;
  }

  .chess-notation__file-proper button,
  .chess-notation__rank-proper button {
    width: 25%;
  }

  .chess-notation__final-results {
    font-size: 20vw;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: white;
    font-family: var(--monospace);
  }

  .chess-notation__final-results.is-invalid {
    background: var(--negative);
  }

  .chess-notation__final-results.is-pending{
    background: var(--mid);
  }

  .chess-notation__final-results span {
    display: flex;
  }

  .chess-notation__piece button.is-active,
  .chess-notation__rank button.is-active,
  .chess-notation__file button.is-active   {
    background: var(--active);
  }

  :root:root .chess-notation__check {
    stroke: var(--putty);
  }
  
  :root:root .chess-notation__check,
  :root:root .chess-notation__error,
  :root:root .chess-notation__pending  {
    margin: 15px;
  }
</style>